import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Input,
    Button,
    Table,
    Badge,
    FormGroup,
    Label,
    Spinner
} from "reactstrap";
import { useAuth } from "../../Provider/AuthProvider";
import ClientSelectionModal from "./ClientSelectionModal";
import Categories from "./Categories";
import './PriceRangeFilter.css';
import { CartItem, Product, PriceRange, Cart, ApiResponse } from "./Interfaces";
import { addToCart } from "./cartUtils";
import CreateReferenceModal from "./CreateReferenceModal";
import CreateProductModal from "./CreateProductModalProps";
import RetourModal from './RetourModal'; // Adjust path as needed
import { useSearch } from './useSearch';

const Vendeur = () => {
    const { user, changeProduct, Products, RefProduct, setRefProduct, setLoading, Loading, brands, setBrands, setSelectedBrands  , selectedBrands} = useAuth();
    const { searchByReference } = useSearch(); // Add this
    const [screenWidth, setWidth] = useState<number>(window.innerWidth);
    const [cart, setCart] = useState<CartItem[]>([]);
    const [createRefModalOpen, setCreateRefModalOpen] = useState(false);
    const [createProductModalOpen, setCreateProductModalOpen] = useState(false);
    const [clientModalOpen, setClientModalOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
    const [defaultWarehouse, setDefaultWarehouse] = useState(0);
    const [quantityInputs, setQuantityInputs] = useState<{ [productId: string]: string }>({});
    const [currentClient, setCurrentClient] = useState<string | null>(null);
    const [expandedDescriptions, setExpandedDescriptions] = useState<Record<string, boolean>>({});
    const [productForReference, setProductForReference] = useState<Product | null>(null);
    const [priceRange, setPriceRange] = useState<PriceRange>({ min: 0, max: 10000 });
    const [absoluteMinMax, setAbsoluteMinMax] = useState<PriceRange>({ min: 0, max: 10000 });
    const [immatInputs, setImmatInputs] = useState<{ [productId: string]: string }>({});
    const [selectedRegions, setSelectedRegions] = useState<{ [productId: string]: string }>({});
    const [articleNoForReference, setArticleNoForReference] = useState<string | null>(null);
    const [selectedWarehouses, setSelectedWarehouses] = useState<{ [productId: string]: string }>({});
    const [retourModalOpen, setRetourModalOpen] = useState(false);


    useEffect(() => {
        const handleStorageChange = () => {
            const savedCart = localStorage.getItem('cart');
            const parsedCart: Cart = savedCart ? JSON.parse(savedCart) : { client: '', items: [] };
            setCart(parsedCart.items || []);
            setCurrentClient(parsedCart.client || null);
        };

        handleStorageChange();
        window.addEventListener('cart-updated', handleStorageChange);
        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('cart-updated', handleStorageChange);
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const handleWarehouseChange = (productId: string, warehouseId: string) => {
        
        setSelectedWarehouses(prev => ({
            ...prev,
            [productId]: warehouseId
        }));


    };
    const handleCreateReference = (data: {
        ref: string;
        originalRef: string;
        name: string;
        price: string;
        brand: string;
        categoryApa: string;
        categoryGolda: string;
    }) => {
    };



    const handleSearch = async () => {
        if (!RefProduct?.trim()) return;

        // Reset all filters
        setBrands({}); // Reset the brands data from context
        setSelectedBrands([]); 
        setPriceRange({ min: 0, max: 10000 });
        setImmatInputs({});
        setSelectedRegions({});
        setSelectedWarehouses({});

        setLoading(true);
        try {
            const searchResult = await searchByReference(RefProduct);
            if (searchResult?.default_warehouse) {
                setDefaultWarehouse(searchResult.default_warehouse);
            }
            // Products and brands are already updated by the hook
        } catch (error) {
            console.error('Error in search:', error);
            changeProduct([]);
            setBrands({});
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (Products && Products.length > 0) {
            const prices = Products.map(p => {
                const price = p.crm?.price_ttc
                return price ? parseFloat(price.toString()) : 0;
            });

            if (prices.length > 0) {
                const min = Math.min(...prices);
                const max = Math.max(...prices);
                setAbsoluteMinMax({ min: Math.min(0, min), max });
                setPriceRange({ min: Math.min(0, min), max });
            }
        }
    }, [Products]);

    const isProductInPriceRange = (product: Product): boolean => {
        const price = product.crm?.price_ttc
        const priceValue = price ? parseFloat(price.toString()) : 0;
        return priceValue >= priceRange.min && priceValue <= priceRange.max;
    };

    const handlePriceChange = (min: number, max: number) => {
        const validatedMin = Math.max(0, Math.min(min, absoluteMinMax.max - 1));
        const validatedMax = Math.min(absoluteMinMax.max, Math.max(max, 1));
        const finalMin = Math.min(validatedMin, validatedMax - 1);
        const finalMax = Math.max(validatedMax, finalMin + 1);

        if (finalMax - finalMin >= 1) {
            setPriceRange({ min: finalMin, max: finalMax });
        }
    };

    const handleAddToCart = (product: Product) => {
        const quantity = parseInt(quantityInputs[product.crm?.id ?? ''] || '1', 10) || 1;
        const immat = immatInputs[product.crm?.id ?? ""];
        const warehouse = selectedWarehouses[product.crm?.id ?? ""] || user.conf.MAIN_DEFAULT_WAREHOUSE;

        const savedCart = localStorage.getItem('cart');
        const cart: Cart = savedCart ? JSON.parse(savedCart) : { client: '', items: [], clientInfo: null };

        if (!cart.client) {
            const Product = {
                ...product,
                quantity: quantity,
                immat: immat,
                warehouse: warehouse
            };
            setSelectedProduct(Product as any); // Correction TypeScript
            setClientModalOpen(true);
            return;
        }

        const updatedCart = addToCart(
            product,
            cart.client,
            quantity,
            immat,
            warehouse,
        );
        const finalCart = {
            ...cart, 
            items: updatedCart.items, 
            client: cart.client 
        };

        localStorage.setItem('cart', JSON.stringify(finalCart));
        window.dispatchEvent(new Event('cart-updated'));

        setQuantityInputs(prev => ({ ...prev, [product.tecdoc?.articleNo ?? '']: '1' }));
    };
    const handleQuantityChange = (productId: string, value: string) => {
        if (value === "" || (/^\d+$/.test(value) && parseInt(value) > 0)) {
            setQuantityInputs(prev => ({
                ...prev,
                [productId]: value
            }));
        }
    };

    const handleQuantityFocus = (productId: string) => {
        if (quantityInputs[productId] === "1" || !quantityInputs[productId]) {
            setQuantityInputs(prev => ({
                ...prev,
                [productId]: ""
            }));
        }
    };

    const formatStockDisplay = (product: Product) => {
            if (!product.stock || Object.keys(product.stock).length === 0) {
            return product.stock_reel || '0';
        }

        const stockEntries = Object.entries(product.stock);
    
        return stockEntries.map(([location, stock], index) => (
            <React.Fragment key={location}>
                {`${location}: ${stock.stock}`}
                {index < stockEntries.length - 1 && <br />}
            </React.Fragment>
        ));
    };

    const onKeyDownPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearch();
        }
    }
    return (
        <React.Fragment>
            <div className="page-content pb-0">
                <Container fluid className="">
                    <Card className="mb-4 shadow-sm">
                        <CardBody>
                            <Row className="g-3 align-items-center justify-content-between">
                                {/* Left side buttons */}
                                <Col md="auto">
                                    <div className="d-flex align-items-center gap-2">
                                        <Button
                                            color="danger"
                                            className=""
                                            onClick={() => setRetourModalOpen(true)}
                                        >
                                            <i className="ri ri-arrow-go-back-line me-2 fs-16" />
                                            Retour Bon Commande
                                        </Button>

                                        <Button
                                            color="warning"
                                            className=""
                                            onClick={() => setCreateProductModalOpen(true)}
                                        >
                                            <i className="ri  ri-paint-fill  me-2 fs-16" />
                                            PSP
                                        </Button>
                                    </div>
                                </Col>

                                {/* Search bar on the right end */}
                                <Col md={6} className="d-flex justify-content-end">
                                    <div className="d-flex align-items-center gap-2 w-100 justify-content-end">
                                        <div style={{ minWidth: '300px', maxWidth: '400px' }}>
                                            <div className="d-flex align-items-center mb-0" style={{ marginBottom: '0 !important' }}>                                                <div className="input-group">
                                                <Input
                                                    type="text"
                                                    name="reference"
                                                    value={RefProduct}
                                                    placeholder="Rechercher une référence..."
                                                    onChange={(e) => setRefProduct(e.target.value)}
                                                    className="border-end-0"
                                                    onKeyDown={onKeyDownPress}
                                                />
                                                <span className="input-group-text bg-light border-start-0">
                                                    <i className="ri ri-search-line" />
                                                </span>
                                            </div>
                                            </div>
                                        </div>

                                        <Button
                                            color="primary"
                                            className=""
                                            onClick={handleSearch}
                                        >
                                            <i className="ri ri-search-line me-2" />
                                            Rechercher
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                    <Categories />
                    <Row>
                        <Col md={2} className="sticky-sidebar">
                            {Products && Products.length > 0 && brands && Object.keys(brands).length > 0 &&  (
                                <>
                                    <h5 className="mb-2" style={{ color: "#0d6efd" }}>Filtrer par Marque</h5>
                                    <div className="mb-0">
                                        <Input
                                            type="text"
                                            placeholder="Rechercher une marque..."
                                            className="mb-3"
                                            onChange={(e) => {
                                                // Implement brand search if needed
                                            }}
                                        />
                                    </div>
                                    <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                                        {Object.keys(brands).map((brandKey, index) => {
                                            const normalizedBrand = brandKey.trim().toLowerCase();
                                            return (
                                                <div key={index} className="form-check mb-2">
                                                    <Input
                                                        type="checkbox"
                                                        id={`brand-${index}`}
                                                        className="form-check-input"
                                                        checked={selectedBrands.includes(normalizedBrand)}
                                                        onChange={() => {
                                                            setSelectedBrands((prev) =>
                                                                prev.includes(normalizedBrand)
                                                                    ? prev.filter((b) => b !== normalizedBrand)
                                                                    : [...prev, normalizedBrand]
                                                            );
                                                        }}
                                                    />
                                                    <Label for={`brand-${index}`} className="form-check-label">
                                                        {brandKey}
                                                    </Label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <div className="price-range-filter mt-4">
                                        <header>
                                            <h5 style={{ color: "#0d6efd" }}>Filtrer par Prix</h5>
                                        </header>
                                        <div className="d-flex gap-2 mb-2">
                                            <FormGroup className="flex-grow-1">
                                                <Label className="small">Min (€)</Label>
                                                <Input
                                                    type="number"
                                                    min={0}
                                                    max={absoluteMinMax.max}
                                                    value={priceRange.min}
                                                    onChange={(e) => handlePriceChange(
                                                        Math.min(Number(e.target.value), priceRange.max),
                                                        priceRange.max
                                                    )}
                                                    step="1"
                                                    className="form-control-sm"
                                                />
                                            </FormGroup>
                                            <FormGroup className="flex-grow-1">
                                                <Label className="small">Max (€)</Label>
                                                <Input
                                                    type="number"
                                                    min={0}
                                                    max={absoluteMinMax.max}
                                                    value={priceRange.max}
                                                    onChange={(e) => handlePriceChange(
                                                        priceRange.min,
                                                        Math.max(Number(e.target.value), priceRange.min)
                                                    )}
                                                    step="1"
                                                    className="form-control-sm"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className="d-flex justify-content-between mb-1">
                                            <span className="price-label">{priceRange.min}€</span>
                                            <span className="price-label">{priceRange.max}€</span>
                                        </div>
                                        <div className="slider mt-2">
                                            <div
                                                className="progress"
                                                style={{
                                                    left: `${((priceRange.min - absoluteMinMax.min) / (absoluteMinMax.max - absoluteMinMax.min)) * 100}%`,
                                                    right: `${100 - ((priceRange.max - absoluteMinMax.min) / (absoluteMinMax.max - absoluteMinMax.min)) * 100}%`
                                                }}
                                            ></div>
                                        </div>
                                        <div className="range-input">
                                            <input
                                                type="range"
                                                className="range-min"
                                                min={0}
                                                max={absoluteMinMax.max}
                                                value={priceRange.min}
                                                onChange={(e) => handlePriceChange(parseInt(e.target.value), priceRange.max)}
                                                step="1"
                                            />
                                            <input
                                                type="range"
                                                className="range-max"
                                                min={0}
                                                max={absoluteMinMax.max}
                                                value={priceRange.max}
                                                onChange={(e) => handlePriceChange(priceRange.min, parseInt(e.target.value))}
                                                step="1"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </Col>

                        <Col md={10}>
                            <Card className="shadow-sm">
                                <CardBody>
                                    <div className="table-responsive">
                                        <Table hover>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: screenWidth > 1400 ? 200 : 150 }}>Image</th>
                                                    <th>Produit</th>
                                                    <th>Prix</th>
                                                    <th>Stock</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Loading ? (
                                                    <tr>
                                                        <td colSpan={5} className="text-center">
                                                            <Spinner color="primary" />
                                                        </td>
                                                    </tr>
                                                ) : Products!.length > 0 ? (
                                                    [...Products!]
                                                            .sort((a, b) => {
                                                                const refA = a.tecdoc?.articleNo?.toLowerCase() || a.crm?.ref?.toLowerCase() || "";
                                                                const refB = b.tecdoc?.articleNo?.toLowerCase() || b.crm?.ref?.toLowerCase() || "";
                                                                const searched = RefProduct?.toLowerCase() || "";

                                                                const aMatches = refA.includes(searched) ? 1 : 0;
                                                                const bMatches = refB.includes(searched) ? 1 : 0;

                                                                // Products that don't match remain in their original order
                                                                return bMatches - aMatches;
                                                            })
                                                            .map((product, index) => {
                                                            const productBrand = product.tecdoc?.brandName?.toLowerCase().trim();
                                                            const productId = index.toString();

                                                            if (selectedBrands.length > 0 && (!productBrand || !selectedBrands.includes(productBrand))) {
                                                                return null;
                                                            }

                                                                const reference =
                                                                    product.tecdoc.details?.[0]?.replacedNumber?.array?.[0]?.replaceNumber
                                                                        ? `remplace: ${product.tecdoc.details[0].replacedNumber.array[0].replaceNumber}`
                                                                        : product.tecdoc.details?.[0]?.replacedByNumber?.array?.[0]?.replaceNumber
                                                                            ? `remplacée par: ${product.tecdoc.details[0].replacedByNumber.array[0].replaceNumber}`
                                                                        : '';

                                                                const description = product.tecdoc.details?.[0]?.articleAttributes?.array
                                                                    ? product.tecdoc.details[0].articleAttributes.array
                                                                    .map(attr => `${attr.attrName}: ${attr.attrValue} ${attr.attrUnit || ''}`)
                                                                    .join(' | ')
                                                                : product.crm?.description || product.crm?.label || product.tecdoc?.description || 'N/A';

                                                            const isExpanded = expandedDescriptions[productId] || false;
                                                            const displayDescription = isExpanded
                                                                ? description
                                                                : description.length > 100
                                                                    ? `${description.substring(0, 100)}...`
                                                                    : description;

                                                            const toggleDescription = () => {
                                                                setExpandedDescriptions(prev => ({
                                                                    ...prev,
                                                                    [productId]: !prev[productId]
                                                                }));
                                                            };

                                                            return (
                                                                <tr key={productId}>
                                                                    <td>
                                                                        {product?.thumb && (
                                                                            <img
                                                                                src={`https://api.apapiecesauto.fr/apims/imgTecdoc.php?a=${product.thumb}`}
                                                                                alt={product.crm?.label || product.tecdoc?.articleName || 'Product image'}
                                                                                style={{
                                                                                    width: screenWidth > 1400 ? '200px' : '150px',
                                                                                    height: '150px',
                                                                                    objectFit: 'contain',
                                                                                    borderRadius: '4px',
                                                                                }}
                                                                                className="border"
                                                                                onError={(e) => {
                                                                                    (e.target as HTMLImageElement).style.display = 'none';
                                                                                }}
                                                                            />
                                                                        )}
                                                                        {product?.EPRimages?.[0]?.photo && !product?.thumb && (
                                                                            <img
                                                                                src={`https://api.apapiecesauto.fr${product.EPRimagesPath || ''}${product.EPRimages[0].photo}`}
                                                                                alt={product.crm?.label || product.tecdoc?.articleName || 'ERP Product image'}
                                                                                style={{
                                                                                    width: screenWidth > 1400 ? '200px' : '150px',
                                                                                    height: '150px',
                                                                                    objectFit: 'contain',
                                                                                    borderRadius: '4px',
                                                                                }}
                                                                                className="border"
                                                                                onError={(e) => {
                                                                                    (e.target as HTMLImageElement).style.display = 'none';
                                                                                }}
                                                                            />
                                                                        )}
                                                                        {!product?.thumb && !product?.EPRimages?.[0]?.photo && (
                                                                            <img
                                                                                src="https://api.apapiecesauto.fr/apims/imgLiz.php?id=2129875&path=&extension="
                                                                                alt={product.crm?.label || product.tecdoc?.articleName || 'ERP Product image'}
                                                                                style={{
                                                                                    width: screenWidth > 1400 ? '200px' : '150px',
                                                                                    height: '150px',
                                                                                    objectFit: 'contain',
                                                                                    borderRadius: '4px',
                                                                                }}
                                                                                className="border"
                                                                                onError={(e) => {
                                                                                    (e.target as HTMLImageElement).style.display = 'none';
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            maxWidth: '300px',
                                                                            wordWrap: 'break-word',
                                                                            whiteSpace: 'normal',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                        onClick={toggleDescription}
                                                                    >
                                                                        <div>
                                                                            <strong style={{ color: '#0d6efd' }}>
                                                                                {product.crm?.label || product.tecdoc?.articleName || 'N/A'}
                                                                            </strong>
                                                                        </div>
                                                                        <div>
                                                                            {isExpanded ? description : (
                                                                                <>
                                                                                    {description.length > 100 ? `${description.substring(0, 100)} ` : description}
                                                                                    {description.length > 100 && (
                                                                                        <Button
                                                                                            color="link"
                                                                                            size="sm"
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                toggleDescription();
                                                                                            }}
                                                                                            className="p-0"
                                                                                            style={{
                                                                                                textDecoration: 'none',
                                                                                                verticalAlign: 'middle',
                                                                                                fontSize: '16px'
                                                                                            }}
                                                                                            title="Voir plus"
                                                                                        >
                                                                                            <i className="ri-add-circle-line" style={{ fontSize: '20px', color: 'green' }} />
                                                                                        </Button>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                            {isExpanded && description.length > 100 && (
                                                                                <Button
                                                                                    color="link"
                                                                                    size="sm"
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        toggleDescription();
                                                                                    }}
                                                                                    className="p-0 ms-1"
                                                                                    style={{
                                                                                        textDecoration: 'none',
                                                                                        fontSize: '16px'
                                                                                    }}
                                                                                    title="Voir moins"
                                                                                >
                                                                                    <i className="ri-indeterminate-circle-line" style={{ fontSize: '20px', color: 'green' }} />
                                                                                </Button>
                                                                            )}
                                                                        </div>
                                                                        {reference && (
                                                                            <div>
                                                                                <strong style={{ color: '#000' }}>{reference}</strong>
                                                                            </div>
                                                                        )}
                                                                        {(product.tecdoc?.articleNo || product.crm?.ref) && (
                                                                            <div>
                                                                                <strong>
                                                                                    <span className="text-success">
                                                                                        Référence: {product.tecdoc?.articleNo || product.crm?.ref}
                                                                                    </span>
                                                                                </strong>
                                                                            </div>
                                                                        )}
                                                                        <Badge className="me-1" color="primary">{product.tecdoc?.brandName}</Badge>
                                                                        {product.consigne?.rowid && (
                                                                            <Badge color="warning" className="me-1">Consigne : ({Number(product.consigne?.price_ttc).toFixed(2)} € )</Badge>
                                                                        )}
                                                                        {!product.crm?.ref && !product.came_from && (
                                                                            <Badge color="danger" className="mb-2">Non référencé</Badge>
                                                                        )}
                                                                    </td>
                                                                    <td className="text-nowrap">
                                                                        <div className="d-flex flex-column">
                                                                            <span className="fw-bold text-success">
                                                                                {product.crm?.price_ttc ? `${Number(product.crm.price_ttc).toFixed(2)} € TTC` : '0.00 € TTC'}
                                                                            </span>
                                                                            <span className="medium text-muted">
                                                                                ({product.crm?.price
                                                                                    ? `${Number(product.crm.price).toFixed(2)} € HT`
                                                                                    : '0.00 € HT'})
                                                                            </span>
                                                                        </div>
                                                                        {product?.golda && Number(product.golda.prixTTC) > 0 && (
                                                                            <div className="small text-muted mt-1">
                                                                                Prix Public: {Number(product.golda.prixTTC).toFixed(2)} €
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {formatStockDisplay(product)}
                                                                    </td>
                                                                    <td>
                                                                        {product.crm?.price_ttc && Number(product.crm.price_ttc) > 0 ? (


                                                                            <>
                                                                                <div className="d-flex align-items-center gap-2 mb-2">
                                                                                    <Button
                                                                                        color="primary"
                                                                                        size="sm"
                                                                                        onClick={() => handleAddToCart(product)}
                                                                                        disabled={(() => {
                                                                                            // IMPORTANT : Plus d'exception pour product.came_from
                                                                                            // Le bouton suit la même logique que pour ref
                                                                                            
                                                                                            // Get the selected warehouse ID from dropdown
                                                                                            const selectedWarehouseId = selectedWarehouses[product.crm?.id ?? ''];

                                                                                            // If no selection, use default logic
                                                                                            if (!selectedWarehouseId) {
                                                                                                return !(
                                                                                                    product.stock &&
                                                                                                    Object.entries(product.stock).length > 0 &&
                                                                                                    Object.entries(product.stock)[0][1].stock > 0
                                                                                                );
                                                                                            }

                                                                                            // Check if selected ID is from fournisseurs
                                                                                            const isFournisseur = product.fournisseurs &&
                                                                                                Object.values(product.fournisseurs).some(f => f.idwh.toString() === selectedWarehouseId);

                                                                                            // If it's a fournisseur, NEVER disable (always enabled)
                                                                                            if (isFournisseur) {
                                                                                                return false;
                                                                                            }

                                                                                            // If it's a warehouse, check its stock
                                                                                            const selectedWarehouse = product.stock &&
                                                                                                Object.entries(product.stock).find(([location, stockData]) =>
                                                                                                    stockData.idwh.toString() === selectedWarehouseId
                                                                                                );

                                                                                            // If we found the selected warehouse, check its stock
                                                                                            if (selectedWarehouse) {
                                                                                                const stockValue = selectedWarehouse[1].stock;
                                                                                                return !(stockValue > 0);
                                                                                            }

                                                                                            // Fallback to default logic
                                                                                            return !(
                                                                                                product.stock &&
                                                                                                Object.entries(product.stock).length > 0 &&
                                                                                                Object.entries(product.stock)[0][1].stock > 0
                                                                                            );
                                                                                        })()}
                                                                                    >
                                                                                        <i className="ri ri-shopping-cart-line me-1" />
                                                                                        Ajouter au panier
                                                                                    </Button>
                                                                                    {/*<Button*/}
                                                                                    {/*    color="primary"*/}
                                                                                    {/*    size="sm"*/}
                                                                                    {/*    onClick={() => handleAddToCart(product)}*/}
                                                                                    {/*>*/}
                                                                                    {/*    <i className="ri ri-shopping-cart-line me-1" />*/}
                                                                                    {/*    Ajouter au panier*/}
                                                                                    {/*</Button>*/}
                                                                                    <Input
                                                                                        type="text"
                                                                                        min="1"
                                                                                        style={{ width: '60px', height: '30px' }}
                                                                                        value={quantityInputs[product.crm?.id ?? ''] ?? '1'}
                                                                                        onChange={(e) =>
                                                                                            handleQuantityChange(product.crm?.id ?? '', e.target.value)
                                                                                        }
                                                                                        onFocus={() => handleQuantityFocus(product.crm?.id ?? '')}
                                                                                    />
                                                                                </div>
                                                                                {/* Champ immatriculation – toujours affiché (suppression de !product.came_from) */}
                                                                                <div className="mb-2">
                                                                                    <Input
                                                                                        type="text"
                                                                                        style={{ width: '200px', height: '30px' }}
                                                                                        placeholder="Immatriculation"
                                                                                        value={immatInputs[product.crm?.id ?? ''] ?? ''}
                                                                                        onChange={(e) =>
                                                                                            setImmatInputs((prev) => ({
                                                                                                ...prev,
                                                                                                [product.crm?.id ?? '']: e.target.value,
                                                                                            }))
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                                {/* Select entrepôts / fournisseurs – toujours affiché (suppression de !product.came_from) */}
                                                                                <div>
                                                                                    <Input
                                                                                        type="select"
                                                                                        style={{
                                                                                            height: '30px',
                                                                                            lineHeight: '30px',
                                                                                            paddingTop: '0',
                                                                                            paddingBottom: '0',
                                                                                            fontSize: '13px',
                                                                                            width: '200px',
                                                                                        }}
                                                                                        defaultValue={defaultWarehouse}
                                                                                        onChange={(e) => handleWarehouseChange(product.crm?.id ?? '', e.target.value)}
                                                                                    >
                                                                                        {product.stock &&
                                                                                            Object.entries(product.stock).slice(0, 1)
                                                                                            .map(([location, stockdata]) => (
                                                                                                <option key={stockdata.idwh} value={stockdata.idwh}>
                                                                                                    {location.trim()}
                                                                                                </option>
                                                                                            ))}
                                                                                        {product.fournisseurs &&
                                                                                            Object.entries(product.fournisseurs)
                                                                                            .map(([location, stockdata]) => (
                                                                                                <option key={stockdata.idwh} value={stockdata.idwh}>
                                                                                                    {location.trim()}
                                                                                                </option>
                                                                                            ))}
                                                                                    </Input>
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            !product.came_from && !product.crm?.ref && user?.perms?.produit?.creer === 1 && (
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <Button
                                                                                        color="warning"
                                                                                        size="sm"
                                                                                        onClick={() => {
                                                                                            setProductForReference(product);
                                                                                            setCreateRefModalOpen(true);
                                                                                            setArticleNoForReference(product.tecdoc?.articleNo || null);
                                                                                        }}
                                                                                    >
                                                                                        <i className="ri ri-error-warning-line me-1" />
                                                                                        Créer La Fiche
                                                                                    </Button>
                                                                                </div>
                                                                            )
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={5} className="text-center">
                                                            Aucun produit trouvé.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <ClientSelectionModal
                        isOpen={clientModalOpen}
                        toggle={() => setClientModalOpen(false)}
                        onConfirm={(clientName, rowid, newClientInfo) => {
                            setCurrentClient(clientName);
                            if (selectedProduct) {
                                const quantity = (selectedProduct as any).quantity || 1;
                                const immat = (selectedProduct as any).immat;
                                const warehouse = (selectedProduct as any).warehouse || user.conf.MAIN_DEFAULT_WAREHOUSE;

                                const updatedCart = addToCart(
                                    selectedProduct,
                                    clientName,
                                    quantity,
                                    immat ,
                                    warehouse,
                                    rowid ? { rowid } : newClientInfo ? {
                                        prenom: newClientInfo.prenom,
                                        nom: newClientInfo.nom,
                                        societe: newClientInfo.societe,
                                        codePostal: newClientInfo.codePostal,
                                        telephone: newClientInfo.telephone
                                    } : undefined
                                );
                                setCart(updatedCart.items);
                            }
                            setClientModalOpen(false);
                        }}
                    />
                    <CreateReferenceModal
                        isOpen={createRefModalOpen}
                        toggle={() => {
                            setCreateRefModalOpen(false);
                            setProductForReference(null);
                        }}
                        initialRef={articleNoForReference ?? ""}
                        product={productForReference}
                        onCreate={handleCreateReference}
                    /> 
                    <CreateProductModal
                        isOpen={createProductModalOpen}
                        toggle={() => setCreateProductModalOpen(false)}
                    />
                </Container>
                <RetourModal
                    isOpen={retourModalOpen}
                    toggle={() => setRetourModalOpen(false)}
                    user={user}
                />
            </div>
        </React.Fragment>
    );
};

export default Vendeur;